import React, { useState, useEffect } from 'react';
import { Container, AppBar, Toolbar, Typography, Tabs, Tab, Box } from '@mui/material';
import DailyView from './components/DailyView';
import WeeklyView from './components/WeeklyView';
import MonthlySummary from './components/MonthlySummary';
import { getConfiguracion } from './services/api';
import AdminPanel from './components/AdminPanel';

function TabPanel(props) {
  const { children, value, index, ...other } = props;
  return (
    <div role="tabpanel" hidden={value !== index} {...other}>
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

function App() {
  const [tabValue, setTabValue] = useState(0);
  const [tarifa, setTarifa] = useState(8.0);

  useEffect(() => {
    loadConfiguracion();
  }, []);

  const loadConfiguracion = async () => {
    try {
      const response = await getConfiguracion();
      setTarifa(response.data.tarifa_hora);
    } catch (error) {
      console.error('Error loading configuration:', error);
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div className="App">
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
            Limpieza Airbnb
          </Typography>
          <Typography variant="body2">
            Tarifa: {tarifa}€/hora
          </Typography>
        </Toolbar>
      </AppBar>

      <Container maxWidth="lg">
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={tabValue} onChange={handleTabChange}>
            <Tab label="Vista Diaria" />
            <Tab label="Vista Semanal" />
            <Tab label="Resumen Mensual" />
            <Tab label="Administración" />
          </Tabs>
        </Box>

        <TabPanel value={tabValue} index={0}>
          <DailyView />
        </TabPanel>
        <TabPanel value={tabValue} index={1}>
          <WeeklyView />
        </TabPanel>
        <TabPanel value={tabValue} index={2}>
          <MonthlySummary />
        </TabPanel>
        <TabPanel value={tabValue} index={3}>
          <AdminPanel />
        </TabPanel>
      </Container>
    </div>
  );
}

export default App;